/// <reference path="GAdmBase.ts"/>

namespace Gordic.Adm.WebControls {
    export abstract class GAdmDetailBase<T> extends GAdmBase {
        options: IGAdmDetailOptions;
        cnt: GContent & GAdmDetailBase<T>;
        isAuthService: boolean;
        data: T;
        metadata: any;
        savePermissionObj: { permission: boolean, reason: string }
        form: Gordic.Forms.Form;
        editMode: boolean;
        sxs: string;
        objType: number;
        auditPristupu: Gordic.Adm.WebControls.AdmAuditPristupuNew;
        poznamky: Gordic.Adm.WebControls.AdmPoznamkyNew;
        icoBase: string;
        openDialog: boolean;

        createBase(this: GContent & GAdmDetailBase<T>, options: IGAdmDetailOptions) {
            this.cnt = this;
            this.addDefaultValues(options);
            this.cnt.uid = this.options.contentName;
            this.cnt.taskId = this.options.contentName;
            this.data = options.data.data;
            this.metadata = (this.data['MetaData'] != null) ? (this.data as any).MetaData : null;
            this.checkSavePermissions();
            this.checkGridAccess();
            this.createBaseActions();
            this.initContent();
            this.create();
        }

        abstract createTitle(): string;

        abstract createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef;

        abstract createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef;

        abstract createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null;

        abstract createForm();

        abstract setEditMode(editMode: boolean);

        abstract saveData(data: any, close: boolean);

        abstract updateGrid(filter: any, grid: any): any;

        abstract reloadData(filterObj: any, dataObj: any);

        abstract setSxsDetail(): string;

        abstract textPopis(): string | undefined | null;

        abstract create();

        private checkSavePermissions() {
            if ((this.data as any).Permissions) {
                if (this.options.newRecord == true) {
                    this.editMode = true;
                    if ((this.data as any).Permissions.CanCreate.value == true)
                        this.savePermissionObj = { permission: true, reason: "" };
                    else
                        this.savePermissionObj = { permission: false, reason: ((this.data as any).Permissions.CanCreate.value == true) ? "" : (((this.data as any).Permissions.CreateReason != "") ? (this.data as any).Permissions.CreateReason : "jres:33000172") }; //RC 33000172 : Nemáte oprávnění přidávat záznamy.
                } else {
                    this.editMode = false;
                    if ((this.data as any).Permissions.CanWrite.value == true)
                        this.savePermissionObj = { permission: true, reason: "" };
                    else
                        this.savePermissionObj = { permission: false, reason: ((this.data as any).Permissions.CanWrite.value == true) ? "" : (((this.data as any).Permissions.WriteReason != "") ? (this.data as any).Permissions.WriteReason : "jres:33000173") }; //RC 33000173 : Nemáte oprávnění editovat záznamy.
                }
            } else {
                this.savePermissionObj = { permission: false, reason: "" };
            }
        }

        private checkGridAccess() {
            if (this.options.createPreviousAndNextAction == true) {
                if (!this.options.gridRc)
                    this.options.createPreviousAndNextAction = false;
                if (this.options.newRecord == true)
                    this.options.createPreviousAndNextAction = false;
            }
        }

        private addDefaultValues(options: IGAdmDetailOptions) {
            this.options = { ...OptionsDetailDefaults, ...options };
        }

        private initContent() {
            this.cnt.uid = this.options.contentName;
            this.cnt.setBreadcrumbs({
                action: this.cnt.actions.actBaseAction
            })
            if (this.options.newRecord == false)
                this.sxs = this.setSxsDetail();
            if (this.metadata) {
                this.objType = this.metadata.typ_obj;
                // Audit přístupů
                this.auditPristupu = new Gordic.Adm.WebControls.AdmAuditPristupuNew({ sxs: this.sxs, typ_obj: this.objType })
                this.poznamky = new Gordic.Adm.WebControls.AdmPoznamkyNew({ sxs: this.sxs, typ_obj: this.objType, cnt: this.cnt })
            }
        }

        private createBaseActions() {
            this.cnt.actions.addRange({
                actBaseAction: {
                    caption: this.createTitle(),
                    run: (ev, ctx) => {
                        this.cnt.tryCloseAllSignificants();
                    }
                },
                actSave: {
                    caption: "jres:32131041",
                    icon: "gi-save",
                    enabled: this.savePermissionObj.permission && this.options.newRecord,
                    tooltip: this.savePermissionObj.reason,
                    //visible: this.options.newRecord,
                    run: (ev, ctx) => {
                        this.saveBase(ctx.close ?? true);
                    }
                },
                actEdit: {
                    caption: "jres:32000120",
                    icon: "gi-pencil",
                    tooltip: this.savePermissionObj.reason,
                    enabled: this.savePermissionObj.permission && !this.options.newRecord,
                    //visible: !this.options.newRecord,
                    run: (ev, ctx) => {
                        this.setEditModeBase(true);
                    }
                },
                actCancelEdit: {
                    caption: "jres:32000122",
                    icon: "gi-window-close",
                    enabled: this.options.newRecord,
                    //visible: this.options.newRecord,
                    run: (ev, ctx) => {
                         this.reloadDataBase();
                    }
                },
                actClose: {
                    caption: "jres:32131042",
                    icon: "gi-window-close",
                    run: (ev, ctx) => {
                        this.closeAction().done(() => { this.cnt.close(this.returnValueFunction()) });
                    }
                },
                actNext: {
                    caption: "jres:33000001",  //RC 33000001 : Další­
                    captionVisible: "never",
                    icon: "gi-arrow-down",
                    //visible: this.options.createPreviousAndNextAction,
                    run: (ev, ctx) => {
                        this.closeAction().done(() => {
                            this.nextAndPreviousAction(true);
                        })
                    }
                },
                actPrevious: {
                    caption: "jres:33000002", //RC 33000002 : Předchozí
                    captionVisible: "never",
                    icon: "gi-arrow-down gi-rot180",
                    //visible: this.options.createPreviousAndNextAction,
                    run: (ev, ctx) => {
                        this.closeAction().done(() => {
                            this.nextAndPreviousAction(false);
                        })
                    }
                },
                actOpenSeznamAdmVlastnostObecnyObjekt: {
                    caption: "jres:33000420", //RC 33000420 : Vlastnosti navázané na záznam
                    icon: "fa-expand",
                    run: (ev, ctx) => {
                        this.openSeznamAdmVlastnostObecnyObjekt();
                    }
                },
                actOpenDetailOnNewTab: {
                    caption: "jres:33000934", //RC 33000934 : Otevřít na nové kartě
                    icon: "fa-external-link",
                    run: (ev, ctx) => {
                        this.openDetailOnNewTab()
                    }
                }
            })
            var userActions = this.createActions();
            if (userActions != null)
                this.cnt.actions.addRange(userActions);
            if (this.options.gridRc?.current() != undefined) {
                this.cnt.actions.actPrevious?.enabled(this.options.gridRc?.current().prevRow != null);
                this.cnt.actions.actNext?.enabled(this.options.gridRc?.current().nextRow != null);
            } else {
                this.cnt.actions.actPrevious?.enabled(false);
                this.cnt.actions.actNext?.enabled(false);
            }
        }

        createShareActions(): MenuParams {
            var menuItem = $.extend({}, Gordic.Gin.Prefabs.MenuParams.ShareCommandUrl({
                parentContent: this.cnt,
                commandUrl: Gordic.WebApp.Utility.createCommandUrl(
                    null,
                    "OpenDetail",
                    {
                        sxs: this.setSxsDetail(),
                        type: this.objType,
                    },
                    {
                        ticketType: Gordic.Enums.TicketType.None
                    }
                ),
                vlozitDoKalendareOptions: 'Deny',
                prehledUdalostiOptions: 'Deny',
            }), {
                favorite: true,
                enabled: !this.options.newRecord
            })
            if (menuItem.children == null || menuItem.children == undefined)
                menuItem.children = [];
            menuItem.children?.push({
                action: this.cnt.actions.actOpenDetailOnNewTab,
                align: "opposite"
            })
            menuItem.children.forEach((item) => {
                item.action?.update({ enabled: this.options.newRecord == false })
            })
            return menuItem;
        }

        private openDetailOnNewTab() {
            Gordic.WebApp.Utility.openApp(
                null,
                "OpenDetail",
                {
                    sxs: this.setSxsDetail(),
                    type: this.objType
                },
                {
                    ticketType: (this.isAuthService == true) ? Gordic.Enums.TicketType.WithLoginAndContext : Gordic.Enums.TicketType.None
                }
            )
        }

        private setEditModeBase(editMode: boolean) {
            this.editMode = editMode
            // Zviditelnění políček
            if (!this.editMode) {
                this.cnt.findFields().gfield("option", { disabled: true });
            }
            else {
                if (this.metadata?.detail_fields !== undefined && this.metadata?.detail_fields !== null) {
                    var v_detail_fields = this.metadata?.detail_fields as ObjectLiteral<Gordic.AdmIsl.Interface.GAdmFieldMetaData>;
                    var v_pole_jmen = Object.getOwnPropertyNames(v_detail_fields);
                    var _this = this;
                    v_pole_jmen.forEach(function (v_name) {
                        var v_readonly = v_detail_fields[v_name].field_readonly ?? true;
                        var v_is_pk = v_detail_fields[v_name].field_is_pk ?? false;
                        if (!_this.options.newRecord && v_is_pk) {
                            _this.cnt.findFields(v_name).gfield("option", 'disabled', true);
                        }
                        else {
                            _this.cnt.findFields(v_name).gfield("option", { disabled: v_readonly });
                        }
                    });
                    var fields = this.cnt.findFields();
                    for (var i = 0; i < fields.length; i++) {
                        if ($(fields[i]).gfield("option").disabled == false) {
                            $(fields[i]).gfield("focus");
                            break;
                        }
                    }
                }
            }
            // Nastavení základních akcí
            //this.cnt.actions.actSave?.visible(this.editMode);
            //this.cnt.actions.actEdit?.visible(!this.editMode);
            //this.cnt.actions.actNext?.visible(!this.editMode);
            //this.cnt.actions.actPrevious?.visible(!this.editMode);
            //this.cnt.actions.actCancelEdit?.visible(this.editMode);
            this.cnt.actions.actSave?.enabled(this.editMode && this.savePermissionObj.permission);
            this.cnt.actions.actEdit?.enabled(!this.editMode && this.savePermissionObj.permission);
            this.cnt.actions.actNext?.enabled(!this.editMode);
            this.cnt.actions.actPrevious?.enabled(!this.editMode);
            this.cnt.actions.actCancelEdit?.enabled(this.editMode);
            this.cnt.actions.actOpenSeznamAdmVlastnostObecnyObjekt?.enabled(!this.editMode);
            // Edit mode z potomka
            this.setEditMode(this.editMode);
        }

        protected saveBase(close: boolean) {
            this.hideAllFlash();
            var form = this.cnt.findForms("{0}form".format(this.options.contentName))
            var novaData: any = {};
            if (form.gform("isValid")) {
                form.findFields().gfield("model", "collect", novaData);
                this.saveData(novaData, close);
            }
        }

        protected hideAllFlash() {
            this.cnt.hideFlash("save-error");
            for (var i = 0; i < 3; i++) {
                this.cnt.hideFlash("save-error-{0}".format(i))
            }
        }

        private nextAndPreviousAction(next: boolean) {
            if (this.options.gridRc) {
                var obj: any;
                if (next == true)
                    obj = this.options.gridRc.current().nextRow.data;
                else
                    obj = this.options.gridRc.current().prevRow.data;
                this.options.gridRc.move(next);
                var keys = Object.keys(this.getMetadataDetailPkFields());
                var dataObj = {};
                keys.forEach((item) => {
                    dataObj[item] = obj[item];
                })
                dataObj["newRecord"] = false;
                this.reloadDataBase(false, dataObj, false);
                this.cnt.close(this.returnValueFunction());
            }
        }

        getMetadataDetailPkFields() {
            return this.metadata.detail_pk_fields;
        }

        pendingAction(actionName: string, success: boolean = true) {
            this.cnt.actions[actionName]?.setPending((success == true) ? 100 : -1);
        }

        closeAction(closeAfterSave: boolean = false) {
            var _this = this;
            return $.Deferred(function () {
                var def = this;
                if (_this.editMode == true && closeAfterSave == false) {
                    GDlg.confirm("jres:33000010").on("yes", () => { //RC 33000010 : Opravdu chcete opustit detail bez uložení?
                        def.resolve();
                    }).on("no", () => {
                        def.reject();
                    })
                } else
                    def.resolve();
            })
        }

        updateGridBase() {
            if (this.options.currentFilter) {
                var filter = { ... this.options.currentFilter, ... this.metadata.detail_pk_fields };
                var gridElement = this.options.gridRc as any;
                var grid = gridElement.gridInstance.element;
                if (grid.length != 0) {
                    var gridView: Gordic.Data.View = grid.ggrid("getView");
                    return this.updateGrid(filter, grid).then((view: Gordic.Data.View) => {
                        if (view.getDataRows().length > 0) {
                            var data = view.getDataRows(true, "data")[0];
                            if (this.options.newRecord == true)
                                gridView.updateData(data, "add")
                            else
                                gridView.updateData(data, "update")
                            grid.ggrid("setData", gridView);
                            return data;
                        } else {
                            gridView.updateData(this.metadata.detail_pk_fields, "delete");
                            grid.ggrid("setData", gridView);
                        }
                    }).then((data) => {
                        if (data) {
                            grid.ggrid("activeRow", data.data);
                        }
                    })
                }
            } else {
                return $.Deferred(function () {
                    var def = this;
                    def.resolve();
                })
            }
            
        }

        reloadDataBase(openDetail: boolean = true, loaddataObj: any = undefined, delay: boolean = true) {
            var filterObj: any = {
                currentFilter: this.options.currentFilter,
                gridRc: this.options.gridRc,
                createPreviousAndNextAction: !this.options.newRecord
            };
            if (!loaddataObj) {
                var loaddataObj: any = {
                    newRecord: false,
                    ... this.getMetadataDetailPkFields()
                }
            }
            setTimeout(() => {
                this.cnt.close(this.returnValueFunction());
                if (this.options.newRecord == false)
                    this.reloadData(filterObj, loaddataObj);
                else {
                    if (openDetail == true) {
                        if (Object.keys(loaddataObj).length > 1) {
                            this.reloadData({
                                currentFilter: null,
                                gridRc: null,
                                createPreviousAndNextAction: false
                            }, loaddataObj);
                        } 
                    }
                }
            }, (delay == true) ? 700 : 0)
        }

        openDetailOrModalWindow(contentCs: string, filterObj: any, dataObj: any, dialogWidth?: number, dialogHeight?: number) {
            filterObj.openDialog = this.openDialog;
            const cntInitializer = [contentCs, filterObj];
            if (this.openDialog == true)
                $.content().dialogs.showModalWindow(cntInitializer, dataObj, "", dialogWidth ?? 1000, dialogHeight ?? 600)
            else
                $.content().navigate(cntInitializer, dataObj)
        }

        checkErrors(errors: any[]) {
            for (var i = 0; i < errors.length; i++) {
                this.cnt.showFlash({
                    content: "jres:32000124: {0} - {1}".format(this.options.contentCaption, errors[i].message),
                    state: "error",
                    id: "save-error-{0}".format(i)
                })
            }
        }

        showBaseError(message?: string) {
            var textPopis = this.textPopis();
            this.cnt.showFlash({
                content: "jres:32000124: {0} - {1}".format((textPopis != undefined && textPopis != null) ? textPopis : this.options.contentCaption, (message) ? message : "jres:33000174"), //RC 33000174 : Chyba při uložení.
                state: "error",
                id: "save-error"
            })
        }

        showSuccessSave(close: boolean, message?: string) {
            if (close == true) {
                var textPopis = this.textPopis();
                this.cnt.notification("showToast", {
                    title: (textPopis != undefined && textPopis != null) ? textPopis : this.options.contentCaption,
                    content: (message) ? message : "jres:33000175", //RC 33000175 : Uložení proběhlo úspěšně
                    state: "success",
                    icon: "fa-check-circle"
                })
            }
        }

        finishBuilder() {
            var form = this.cnt.findForms("{0}form".format(this.options.contentName))
            Gordic.Utils.Form.markRequired(form);

            form.findFields().on("dblclick", () => {
                if (this.options.newRecord === false && Utils.getCanEdit((this.data as any).Permissions)) {
                    this.setEditModeBase(true);
                    //that.SetMenuButtons(true);
                }
            });

            // zneviditelnění polí
            if (this.metadata?.detail_fields !== undefined && this.metadata?.detail_fields !== null) {
                var v_detail_fields = this.metadata?.detail_fields as ObjectLiteral<Gordic.AdmIsl.Interface.GAdmFieldMetaData>;
                var v_pole_jmen = Object.getOwnPropertyNames(v_detail_fields);
                v_pole_jmen.forEach(function (v_name) {
                    var v_visible = v_detail_fields[v_name].field_visible ?? true;
                    if (!v_visible) {
                        form.findFormRows("row_" + v_name).hide();
                    }
                });
            }
            this.cnt.element.findFields().gfield("model", "apply", this.data);

            var fields = this.cnt.element.findFields();
            if (fields.length > 0)
                $(fields[0]).gfield("focus")

            if (this.options.newRecord)
                this.setEditModeBase(true);
        }

        createFormComplet(): Gordic.Forms.Form {
            this.form = new Gordic.Forms.Form({ name: "{0}form".format(this.options.contentName), customClass: "{0}form".format(this.options.contentName) });
            this.createForm();
            return this.form;
        }

        createStatusBar(): MenuParams[] {
            var menuParams: MenuParams[] = [];
            if (this.options.newRecord == false) {
                if (this.options.addAktivita == true) {
                    menuParams.push({
                        type: "static",
                        caption: "jres:32131030",
                        badge: GAdmGlobals.CreateAktivitaBadge((this.data as any).aktivita)
                    })
                }
                if (this.options.addPlatnost == true) {
                    menuParams.push({
                        type: "static",
                        caption: "jres:33000176", //RC 33000176 : Platnost
                        badge: GAdmGlobals.CreatePlatnostBadge(GAdmGlobals.CreatePlatnost(this.data))
                    })
                }
                if (this.savePermissionObj.permission == false) {
                    menuParams.push({
                        type: "static",
                        align: "opposite",
                        icon: "fa-lock g-state-text g-state-warning",
                        tooltip: this.savePermissionObj.reason
                    })
                }
            } else {
                menuParams.push({
                    type: "static",
                    badge: {
                        customClass: "g-state-info",
                        value: "jres:32000121"
                    }
                })
            }
            return menuParams;
        }

        createFlagNemenne(): GFieldFlagOptions {
            return { text: "jres:32131150", state: "important" }
        }

        getAuditPristupu(): Gordic.Gin.DetailBuilder.GDetailBuilderSbpanelOptionsId {
            return this.auditPristupu.getSidePanel();
        }

        getAuditPristupuTab(): Gordic.Gin.DetailBuilder.TabParamsId  {
            return this.auditPristupu.getPanel();
        }

        getAuditPristupuGroup(): IGTabGroupOptions {
            return this.auditPristupu.getGroup();
        }

        getPoznamky(): Gordic.Gin.DetailBuilder.GDetailBuilderSbpanelOptionsId {
            return this.poznamky.getSidePanel();
        }

        getValidatorDatOdDo(povolNull = false): Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> {
            var validator = new Gordic.Validators.Base({ message: "jres:33000431" }); //RC 33000431 : Hodnoty data od nebo do nejsou v pořádku.
            validator.stopping = true;
            validator.validate = (value, source) => {
                var valueOd = this.cnt.findFields("dat_od").gfield("getValue");
                var valueDo = this.cnt.findFields("dat_do").gfield("getValue");
                if (valueOd == null || valueOd == undefined)
                    return povolNull == true ? true : false
                else if (valueDo == null || valueDo == undefined)
                    return povolNull == true ? true : false
                else if (valueOd > valueDo)
                    return false
                else 
                    return true
            }
            return validator;
        }

        MakeField<T = any>(a_name: string, ...extendedOptions: GControlBoxOptions<T | T[]>[]) {
            var v_row = this.form;
            var v_fieldObj = this.metadata?.detail_fields?.[a_name] ?? null;
            if (v_fieldObj !== null)                                                        // pokud jsem pozadovane pole v poli metadat nalezl, muzu pokracovat, jinak bych mel vyhlasit interni chybu aplikace
            {

                var v_field = v_fieldObj as Gordic.AdmIsl.Interface.GAdmFieldMetaData;      // metadata tohoto pozadovaneho policka
                var v_field_base_type = v_field.field_base_type || "OTHER";     // as Gordic.General.GFieldBaseTypeEnum;
                var v_label: string = v_field.field_caption ?? "";              // popisek policka
                var v_tooltip = v_field.field_tooltip ?? undefined;
                var v_readonly: boolean = !this.editMode;                       // pokud neni editacni rezim tohoto okna, potom jsou vsechna pole pouze na cteni
                var v_is_pk: boolean = v_field.field_is_pk ?? false;            // zjistim, zda je soucast PK
                if (this.editMode)                                              // pokud je editacni rezim okna - potom pole jsou obecne pristupna
                {
                    v_readonly = v_field.field_readonly ?? true;                // server mi v tom pripade muze prikazat, ze i presto ma byt pole pouze pro cteni
                    if (!this.options.newRecord && v_is_pk)
                        v_readonly = true;
                }

                // zkusim vytvorit pole validatoru
                var v_validators: (Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> | Gordic.Validators.ValidatorOptions & { type?: string } | null)[];
                v_validators = new Array();
                if (v_field.field_mandatory ?? false) {
                    v_validators.push(new Gordic.Validators.Required());
                } 

                v_row = this.form.addRow({
                    label: v_label,
                    name: "row_" + a_name
                });

                switch (v_field_base_type) {
                    case "TEXT":
                        if (v_field.field_size !== undefined && v_field !== null)
                            v_validators.push(new Gordic.Validators.Length({ params: { min: 0, max: v_field.field_size } }));

                        var fieldOptions: GStringBoxOptions = {
                            name: a_name,
                            disabled: v_readonly,
                            validators: v_validators,
                            emptyValue: "",
                            tooltip: v_tooltip
                        };

                        var fieldOptionsfinal: GStringBoxOptions = fieldOptions;
                        if (Array.isArray(extendedOptions)) {
                            var pole = extendedOptions as GStringBoxOptions[];
                            pole.forEach(function (option) {
                                fieldOptionsfinal = { ...fieldOptionsfinal, ...option };
                            });
                        } else {
                            var one = extendedOptions as GStringBoxOptions;
                            fieldOptionsfinal = { ...fieldOptionsfinal, ...one };
                        }

                        v_row = this.form.addField("gstringbox", fieldOptionsfinal);
                        break;

                    case "DATETIME":
                        v_row = this.form.addField("gdatebox", {
                            name: a_name,
                            disabled: v_readonly,
                            validators: v_validators,
                            valueType: "datetime",
                            tooltip: v_tooltip
                        });
                        break;
                    case "DATE":

                        var fieldOptionsDate: GDateBoxOptions = {
                            name: a_name,
                            disabled: v_readonly,
                            validators: v_validators,
                            tooltip: v_tooltip
                        };

                        var fieldOptionsDatefinal: GDateBoxOptions = fieldOptionsDate;
                        if (Array.isArray(extendedOptions)) {
                            var poleDate = extendedOptions as GDateBoxOptions[];
                            poleDate.forEach(function (option) {
                                fieldOptionsDatefinal = { ...fieldOptionsDatefinal, ...option };
                            });
                        } else {
                            var oneDate = extendedOptions as GDateBoxOptions;
                            fieldOptionsDatefinal = { ...fieldOptionsDatefinal, ...oneDate };
                        }
                        v_row = this.form.addField("gdatebox", fieldOptionsDatefinal);

                        //v_row = this.form.addField("gdatebox", {
                        //    name: a_name,
                        //    disabled: v_readonly,
                        //    validators: v_validators,
                        //    valueType: "date",
                        //    tooltip: v_tooltip
                        //});
                        break;
                    case "NUMBER":
                    case 1:

                        var numFieldOptions: GNumberBoxOptions = {
                            name: a_name,
                            disabled: v_readonly,
                            validators: v_validators,
                            tooltip: v_tooltip
                        };

                        var numFieldOptionsfinal: GNumberBoxOptions = numFieldOptions;
                        if (Array.isArray(extendedOptions)) {
                            var numPole = extendedOptions as GNumberBoxOptions[];
                            numPole.forEach(function (option) {
                                numFieldOptionsfinal = { ...numFieldOptionsfinal, ...option };
                            });
                        } else {
                            var numOne = extendedOptions as GNumberBoxOptions;
                            numFieldOptionsfinal = { ...numFieldOptionsfinal, ...numOne };
                        }

                        v_row = this.form.addField("gnumberbox", numFieldOptionsfinal);
                        break;

                    case "DECIMAL":
                        //v_row = this.form.addField("gstringbox", {
                        v_row = this.form.addField("gnumberbox", {
                            name: a_name,
                            disabled: v_readonly,
                            validators: v_validators,
                            tooltip: v_tooltip
                        });
                        break;

                    case "BOOLEAN":
                        v_row = this.form.addField("gcheck", {
                            name: a_name,
                            disabled: v_readonly,
                            validators: v_validators,
                            tooltip: v_tooltip
                        });
                        break;
                }
            }
            return v_row;
        }

        MakeSelectField<T = any>(a_name: string, fieldOptions: GSelectBoxOptions<T>, ...extendedOptions: GSelectBoxOptions<T, T | T[]>[]): Gordic.Forms.Form {
            var v_row = this.form;
            var v_fieldObj = this.metadata?.detail_fields?.[a_name] ?? null;
            if (v_fieldObj !== null)                                                        // pokud jsem pozadovane pole v poli metadat nalezl, muzu pokracovat, jinak bych mel vyhlasit interni chybu aplikace
            {
                var v_field = v_fieldObj as Gordic.AdmIsl.Interface.GAdmFieldMetaData;      // metadata tohoto pozadovaneho policka
                var v_label: string = v_field.field_caption ?? "";                          // popisek policka

                var v_readonly: boolean = !this.editMode;           // pokud neni editacni rezim tohoto okna, potom jsou vsechna pole pouze na cteni
                if (this.editMode)                                  // pokud je editacni rezim okna - potom pole jsou obecne pristupna
                    v_readonly = v_field.field_readonly ?? true;    // server mi v tom pripade muze prikazat, ze i presto ma byt pole pouze pro cteni

                // zkusim vytvorit pole validatoru
                var v_validators: (Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> | Gordic.Validators.ValidatorOptions & { type?: string } | null)[];
                v_validators = new Array();
                if (v_field.field_mandatory ?? false) {
                    v_validators.push(new Gordic.Validators.Required());
                }

                fieldOptions.name = a_name;
                fieldOptions.disabled = v_readonly;
                fieldOptions.validators = v_validators;
                if (v_field.field_tooltip)
                    fieldOptions.tooltip = v_field.field_tooltip;
                fieldOptions.dropdown = true;
                fieldOptions.model = a_name + " = " + a_name;

                var fieldOptionsfinal: GSelectBoxOptions<T> = fieldOptions;

                if (Array.isArray(extendedOptions)) {
                    var pole = extendedOptions as GSelectBoxOptions<T>[];
                    pole.forEach(function (option) {
                        fieldOptionsfinal = { ...fieldOptionsfinal, ...option };
                    });
                } else {
                    var one = extendedOptions as GSelectBoxOptions<T>;
                    fieldOptionsfinal = { ...fieldOptionsfinal, ...one };
                }

                //var fieldOptionsfinal: GSelectBoxOptions<T> = { ...fieldOptions, ...extendedOptions };

                v_row = this.form.addRow({
                    label: v_label,
                    name: "row_" + a_name
                });

                v_row = this.form.addField("gselectbox", fieldOptionsfinal);
            }
            return v_row;
        }

        MakeBoolField<T = any>(a_name: string, ...extendedOptions: GControlBoxOptions<T | T[]>[]): Gordic.Forms.Form {
            var v_row = this.form;
            var v_fieldObj = this.metadata?.detail_fields?.[a_name] ?? null;
            if (v_fieldObj !== null)                                                        // pokud jsem pozadovane pole v poli metadat nalezl, muzu pokracovat, jinak bych mel vyhlasit interni chybu aplikace
            {
                var v_field = v_fieldObj as Gordic.AdmIsl.Interface.GAdmFieldMetaData;      // metadata tohoto pozadovaneho policka
                var v_label: string = v_field.field_caption ?? "";                          // popisek policka

                var v_readonly: boolean = !this.editMode;           // pokud neni editacni rezim tohoto okna, potom jsou vsechna pole pouze na cteni
                if (this.editMode)                                  // pokud je editacni rezim okna - potom pole jsou obecne pristupna
                    v_readonly = v_field.field_readonly ?? true;    // server mi v tom pripade muze prikazat, ze i presto ma byt pole pouze pro cteni

                // pro zatržítka je mandatory nesmysl a akorát to dělá problémy
                // zkusim vytvorit pole validatoru
                var v_validators: (Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> | Gordic.Validators.ValidatorOptions & { type?: string } | null)[];
                v_validators = new Array(); // takže to naschvál nechám prázdné
                //if (v_field.field_mandatory ?? false) {
                //    v_validators.push(new Gordic.Validators.Required());
                //}

                v_row = this.form.addRow({
                    label: v_label,
                    name: "row_" + a_name
                });

                var fieldOptions: GCheckOptions = {
                    name: a_name,
                    disabled: v_readonly,
                    validators: v_validators,
                    labelFromRow: "always",

                    modelValueTransform: {
                        apply: function (modelValue) { return modelValue === 1; },
                        collect: function (fieldValue) { return fieldValue === true ? 1 : 0; }
                    }
                };

                var fieldOptionsfinal: GCheckOptions = fieldOptions;
                if (Array.isArray(extendedOptions)) {
                    var pole = extendedOptions as GCheckOptions[];
                    pole.forEach(function (option) {
                        fieldOptionsfinal = { ...fieldOptionsfinal, ...option };
                    });
                } else {
                    var one = extendedOptions as GCheckOptions;
                    fieldOptionsfinal = { ...fieldOptionsfinal, ...one };
                }

                v_row = this.form.addField("gcheck", fieldOptionsfinal);
            }
            return v_row;
        }

        MakeBool10Field<T = any>(a_name: string, ...extendedOptions: GControlBoxOptions<T | T[]>[]): Gordic.Forms.Form {
            var v_row = this.form;
            var v_fieldObj = this.metadata?.detail_fields?.[a_name] ?? null;
            if (v_fieldObj !== null)                                                        // pokud jsem pozadovane pole v poli metadat nalezl, muzu pokracovat, jinak bych mel vyhlasit interni chybu aplikace
            {
                var v_field = v_fieldObj as Gordic.AdmIsl.Interface.GAdmFieldMetaData;      // metadata tohoto pozadovaneho policka
                var v_label: string = v_field.field_caption ?? "";                          // popisek policka

                var v_readonly: boolean = !this.editMode;           // pokud neni editacni rezim tohoto okna, potom jsou vsechna pole pouze na cteni
                if (this.editMode)                                  // pokud je editacni rezim okna - potom pole jsou obecne pristupna
                    v_readonly = v_field.field_readonly ?? true;    // server mi v tom pripade muze prikazat, ze i presto ma byt pole pouze pro cteni

                // pro zatržítka je mandatory nesmysl a akorát to dělá problémy
                // zkusim vytvorit pole validatoru
                var v_validators: (Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> | Gordic.Validators.ValidatorOptions & { type?: string } | null)[];
                v_validators = new Array(); // takže to naschvál nechám prázdné
                //if (v_field.field_mandatory ?? false) {
                //    v_validators.push(new Gordic.Validators.Required());
                //}

                var fieldOptions: GCheckOptions = {
                    name: a_name,
                    disabled: v_readonly,
                    validators: v_validators,
                    labelFromRow: "always",
                    modelValueTransform: {
                        apply: function (modelValue) { return modelValue === 10; },
                        collect: function (fieldValue) { return fieldValue === true ? 10 : 0; }
                    }
                };

                var fieldOptionsfinal: GCheckOptions = fieldOptions;
                if (Array.isArray(extendedOptions)) {
                    var pole = extendedOptions as GCheckOptions[];
                    pole.forEach(function (option) {
                        fieldOptionsfinal = { ...fieldOptionsfinal, ...option };
                    });
                } else {
                    var one = extendedOptions as GCheckOptions;
                    fieldOptionsfinal = { ...fieldOptionsfinal, ...one };
                }

                v_row = this.form.addRow({
                    label: v_label,
                    name: "row_" + a_name
                });

                v_row = this.form.addField("gcheck", fieldOptionsfinal);
            }
            return v_row;
        }

        MakeFormField<T = any>(a_name: string, fieldOptions: GFormBoxOptions<T>): Gordic.Forms.Form {
            var v_row = this.form;
            var v_fieldObj = this.metadata.detail_fields?.[a_name] ?? null;
            if (v_fieldObj !== null)                                                        // pokud jsem pozadovane pole v poli metadat nalezl, muzu pokracovat, jinak bych mel vyhlasit interni chybu aplikace
            {
                var v_field = v_fieldObj as Gordic.AdmIsl.Interface.GAdmFieldMetaData;      // metadata tohoto pozadovaneho policka
                var v_label: string = v_field.field_caption ?? "";                          // popisek policka

                var v_readonly: boolean = !this.editMode;           // pokud neni editacni rezim tohoto okna, potom jsou vsechna pole pouze na cteni
                if (this.editMode)                                  // pokud je editacni rezim okna - potom pole jsou obecne pristupna
                    v_readonly = v_field.field_readonly ?? true;    // server mi v tom pripade muze prikazat, ze i presto ma byt pole pouze pro cteni

                // zkusim vytvorit pole validatoru
                var v_validators: (Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions> | Gordic.Validators.ValidatorOptions & { type?: string } | null)[];
                v_validators = new Array();
                if (v_field.field_mandatory ?? false) {
                    v_validators.push(new Gordic.Validators.Required());
                }

                fieldOptions.name = a_name;
                fieldOptions.disabled = v_readonly;
                fieldOptions.validators = v_validators;
                fieldOptions.model = a_name + " = " + a_name;

                var fieldOptionsfinal: GSelectBoxOptions<T> = fieldOptions;

                v_row = this.form.addRow({
                    label: v_label,
                    name: "row_" + a_name
                });

                v_row = this.form.addField("gformbox", fieldOptionsfinal);
            }
            return v_row;
        }

        MakeFields(a_name: string): Gordic.Forms.Form {
            var v_row = this.form;
            var nameArray = a_name.split(',');
            var _this = this;
            nameArray.forEach(function (name) {
                v_row = _this.MakeField(name);
            });
            return v_row;
        }

        MakeSection(a_name: string): Gordic.Forms.Form {
            var v_row = this.form.addSection(a_name);
            return v_row;
        }

        MakeRow(a_name: string): Gordic.Forms.Form {
            var v_row = this.form;
            var label: string = this.metadata?.detail_fields?.[a_name]?.field_caption ?? "";
            if (label.trim() !== "") {
                v_row = this.form.addRow({
                    label: label,
                    name: "row_" + a_name
                });
            }
            return v_row;
        }

        HideField(a_name: string) {
            var field = this.cnt.findFields(a_name);
            if (field.length > 0)
                field.parent().parent().hide();
        }

        ShowField(a_name: string) {
            var field = this.cnt.findFields(a_name);
            if (field.length > 0)
                field.parent().parent().show();
        }

        private openSeznamAdmVlastnostObecnyObjekt() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostObecnyObjekt"], {
                Id: "SeznamAdmVlastnostObecnyObjekt",
                typ_obj: this.objType,
                ico: this.icoBase ? this.icoBase : null,
                sxs: this.sxs,
                nazev: this.textPopis()
            })
        }

        checkValidatorOdDo(): Gordic.Validators.Base {
            var val = new Gordic.Validators.Base({ message: "jres:33000551" }); //RC 33000551 : Neplatné nastavení datumu od a do.
            val.validate = (value, source) => {
                var datOd = this.cnt.findFields("dat_od").gfield("getValue");
                var datDo = this.cnt.findFields("dat_do").gfield("getValue");
                if (datOd && datDo) {
                    if (datOd <= datDo)
                        return true;
                }
                return false;
            }
            return val;
        }

        returnValueFunction(): any {
            return null;
        }

        // Zvláštní validátory pro knihy

        /**
         * Funkce, která zastřešuje všechny úkony, které je nutné udělat po změně délky evidenčního čísla
         * @param options parametry 
         * @returns
         */
        changeEventLenAc(options: {
            acCisloDoFieldName: string,
            acCisloOdFieldName: string,
            lenAcFieldName: string,
            minValue: number,
            maxValue: number,
            value: any
        }) {
            var validatorsAcCisloDo = [new Gordic.Validators.Required({ stopping: true })]
            var acCisloDoField = this.cnt.findFields(options.acCisloDoFieldName);
            var acCisloOdField = this.cnt.findFields(options.acCisloOdFieldName);
            this.cnt.findFields(options.lenAcFieldName).gfield("validate");
            if (options.value) {
                if (options.value >= options.minValue && options.value <= options.maxValue) {
                    validatorsAcCisloDo.push(this.acCisloDoValidator(options.value))
                    acCisloDoField.gfield("setValidators", validatorsAcCisloDo);
                    acCisloDoField.gfield("validate");
                    acCisloDoField.gfield("setValue", this.createMaxValue(options.value));
                    validatorsAcCisloDo.push(this.createCisloOdDoValidator());
                    acCisloOdField.gfield("setValidators", validatorsAcCisloDo);
                    acCisloOdField.gfield("validate");
                    acCisloOdField.gfield("setValue", 1);
                    return;
                }
            }
            acCisloDoField.gfield("setValue", 0);
            acCisloDoField.gfield("setValidators", validatorsAcCisloDo);
            acCisloOdField.gfield("setValue", 0);
            acCisloOdField.gfield("setValidators", validatorsAcCisloDo);
        }

        getAllAktivita(): number[] {
            return [100, 300, 500, 600, 900]
        }

        private createCisloOdDoValidator(): Gordic.Validators.Base {
            return new Gordic.Validators.Base({
                message: "jres:33000042", //RC 33000042 : Evidenční číslo OD musí být menší než evidenční číslo DO.
                validate: (value, source) => {
                    var acCisloOd = this.cnt.findFields("ac_cislo_od").gfield("getValue")
                    var acCisloDo = this.cnt.findFields("ac_cislo_do").gfield("getValue")
                    if (acCisloOd == null || acCisloOd == undefined)
                        return true;
                    else if (acCisloDo == null || acCisloDo == undefined)
                        return true;
                    else {
                        if (acCisloOd < acCisloDo)
                            return true;
                        return false;
                    }
                }
            })
        }

        private acCisloDoValidator(length: number): Gordic.Validators.Base {
            return new Gordic.Validators.Range({
                stopping: true,
                max: this.createMaxValue(length),
                min: 1
            })
        }

        private createMaxValue(length: number): number {
            var maxstring = "";
            for (var i = 1; i <= length; i++)
                maxstring += "9";
            return parseInt(maxstring);
        }

        rokValidator(): Gordic.Validators.Base {
            return new Gordic.Validators.Base({
                message: "jres:33000041".format(1900, 2050), //RC 33000041 : Rok není nastaven v přípustném rozmezí od {0} do {1}.
                validate: (value, source) => {
                    if (value) {
                        if (value.rok >= 1900 && value.rok <= 2050)
                            return true;
                    }
                    return false
                },
                stopping: true
            })
        }

        acCisloOdChangeEvent(options: {
            errors: Gordic.Validators.Error[],
            maxValueFieldName: string,
            value: any
        }) {
            var maxValueField = this.cnt.findFields(options.maxValueFieldName);
            if (options.value) {
                if (options.errors.length > 0)
                    maxValueField.gfield("setValue", null);
                else
                    maxValueField.gfield("setValue", (options.value == 0) ? 0 : (options.value as number - 1))
            }
            else {
                maxValueField.gfield("setValue", 0)
            }
        }

        createPasswordField(options: {
            name: string;
            form: Gordic.Forms.Form,
            popis: string,
            modelFunction: (op, dto, opt) => void
        }) {
            options.form.addRow({ label: options.popis, name: `${options.name}_row` }).addField("gformbox", {
                name: options.name,
                disabled: true,
                dialogOptions: {
                    width: 500,
                    height: 300,
                    commandBar: [
                        {
                            primary: true,
                            action: new GAction({
                                name: "actOk",
                                caption: "jres:33000243",
                                run: (ev, ctx) => {
                                    this.getDataFromPasswordForm(ev, ctx, options.name);
                                }
                            })
                        }
                    ]
                },
                graphicInput: "oninput",
                itemTemplate: (row) => {
                    let template: string = ""; 
                    let passwd: string = "";
                    switch (row["zpusob_ulozeni"]) {
                        case 0:
                            template += "<b>jres:33000632</b>";
                            passwd += "<i>{0}: {1}</i>".format("jres:29932124", (row["password"] == "" || row["password"] == null || row["password"] == undefined) ? "jres:33001045" :  "******")
                            break;
                        case 10:
                            template += "<b>jres:33000633</b>";
                            break;
                        case 20:
                            template += "<b>jres:33000634</b>";
                            passwd += "<i>{0}: {1}</i>".format("jres:29932124", row["password_map"])
                            break;
                    }
                    return "{0}<br />{1}".format(template, passwd);
                },
                model: function (op, dto, opt) {
                    options.modelFunction(op, dto, opt);
                },
                form: new Gordic.Forms.Form({ name: "password-form", customClass: "password-form" })
                    .addRow("jres:33001043").addField("gradio", { //RC 33001043 : Způsob uložení
                        name: "zpusob_ulozeni",
                        itemClass: "w-12",
                        radios: [
                            { value: 0, label: "jres:33000632" }, //RC 33000632 : Databáze
                            { value: 10, label: "jres:33000633" }, //RC 33000633 : Přímé mapování
                            { value: 20, label: "jres:33000634" } //RC 33000634 : Nepřímé mapování
                        ],
                        change: (ev, ctx) => {
                            var cnt = $.content(ev.target);
                            cnt.findFormRows("password_row").hide();
                            cnt.findFormRows("password_map_row").hide();
                            if (ctx.value != undefined) {
                                switch (ctx.value) {
                                    case 0:
                                        cnt.findFormRows("password_row").show();
                                        break;
                                    case 20:
                                        cnt.findFormRows("password_map_row").show();
                                        break;
                                } 
                            }
                        }
                    })
                    .addRow({ label: "jres:33001044",  name: "password_row" }).addField("gstringbox", Gordic.Prefabs.GStringBox.password({ //RC 33001044 : Heslo
                        obslouzilJsemSbiraniHodnotZPolicekTakAbyNemohlNastatProblemSNeaktualnimSifrovacimKlicem: true
                    }), {
                        name: "password"
                    })
                    .addRow({ label: "jres:33000635", name: "password_map_row" }).addField("gstringbox", {
                        name: "password_map",
                        flag: "required",
                        tag: {
                            text: "jres:33000644", //RC 33000644 : Sem nezadávejte heslo ale pouze informaci, kde je heslo uloženo (odkaz, identifikátor)!
                            state: "warning"
                        }
                    })
            })
        }

        getDataFromPasswordForm(ev, ctx, fieldName) {
            let cnt = $.content(ev.target);
            let form = cnt.findForms("password-form");
            var novaData: any = {};
            form.gform("waitForValues").done(() => {
                if (form.gform("isValid")) {
                    return Prefabs.GStringBox.updateChiperPublicKeys(form).then(() => {
                        form.findFields().gfield("model", "collect", novaData);
                        this.cnt.findForms(`${this.options.contentName}form`).findFields(fieldName).gfield("setValue", novaData);
                        cnt.close();
                    })
                }
            })
        }
    }
}